import React, { Component } from 'react';
import Map from './Map';

class HomeTwo extends Component {

    render() {
        return (
            <div style={{ margin: '1px' }}>
                <Map
                    google={this.props.google}
                    center={{ lat: 19.437578, lng: -99.194915 }}
                    height='230px'
                    zoom={14}
                />
            </div>
        );
    }
}

export default HomeTwo;